import {$controller} from "rapid/index";
import {countries} from "../../common/address/countries";


import {forEach} from "lodash";
const dependencies = ["$Company", "$Users"];


class ClientCreateController extends $controller {
    constructor($injector, $scope, $state) {
        "ngInject";
        super($injector, dependencies);
        this.$state = $state;
        this.$scope = $scope;
        this.$scope.countries = countries;
        this.$scope.colorsValue = {
            R: 0,
            G: 0,
            B: 0,
            HEX: "000000"
        };
        this.$scope.id = this.$stateParams.id;
        this.$scope.isNew = !this.$stateParams.id && this.$scope.id !== 0;

        if (this.$scope.isNew) {
            this.$scope.client = {};
            this.$Company.create({name: "Draft"}).$promise.then((cl) => {
                this.$scope.client = cl;
                this.$scope.client.name = "";
            }).catch((error) => {
                console.log(error);
            });

        } else {
            let company;
            company = this.$Company.get({id: this.$stateParams.id});


            company && company.$promise
                .then((company) => {
                    this.$scope.client = company;
                    if (company.default_design) {
                        this.$scope.colorsValue = company.default_design.colorsValue;
                    }
                    console.log("Companies: ", this.$scope.client);
                }).catch((e) => {
                    console.log(e);
                    this.$state.go("clients");
                });
        }


        let managers;
        // TODO: change this to api-search
        managers = this.$Users.query({groups: 2, page_size: 100000});
        managers && managers.$promise
            .then((managers) => {
                this.$scope.managers = managers;
                forEach(this.$scope.managers, (m) => {
                   m.url = `${process.env.DEVSERVER_PROXY_TARGET || "https://cloud.upreach.com"}${m.url}`;
                });
            }).catch((e) => {
                console.log(e);
                this.$state.go("clients");
            });

        let admins;
        admins = this.$Users.query({groups: 3, page_size: 100000});
        admins && admins.$promise
            .then((admins) => {
                this.$scope.admins = admins;
                forEach(this.$scope.admins, (m) => {
                    m.url = `${process.env.DEVSERVER_PROXY_TARGET || "https://cloud.upreach.com"}${m.url}`;
                });
            }).catch((e) => {
                console.log(e);
                this.$state.go("clients");
            });
    }
    changeHEX() {
        let c = this.$scope.colorsValue;

        if ((c.R || c.R === 0) && (c.G || c.G === 0) && (c.B || c.B === 0)) {
            c.HEX = "" + componentToHex(c.R) + componentToHex(c.G) + componentToHex(c.B);
        }

        function componentToHex(cl) {
            var hex = cl.toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }
    }
    changeRGB() {
        let c = this.$scope.colorsValue;
        if (c.HEX) {
            let bigint = parseInt(c.HEX, 16);
            c.R = (bigint >> 16) & 255;
            c.G = (bigint >> 8) & 255;
            c.B = bigint & 255;
        }
    }
    setColor() {
        let c = this.$scope.colorsValue;
        if (c.HEX) {
            return `#${c.HEX}`;
        }
        if ((c.R || c.R === 0) && (c.G || c.G === 0) && (c.B || c.B === 0)) {
            return `rgb(${c.R},${c.G},${c.B})`;
        }
        return "#000000";
    }

    saveClient() {
        let c = this.$scope.colorsValue;

        if (this.$scope.client.single) {
            this.$scope.client.logistics_handling = "admin";
        } else {
            this.$scope.client.logistics_handling = "client";
        }
        if (this.$scope.client.default_design) {
            this.$scope.client.default_design.colors = {
                rgb: `rgb(${c.R},${c.G},${c.B})`,
                hex: `#${c.HEX}`
            };
            this.$scope.client.default_design.colorsValue = this.$scope.colorsValue;
        }

        this.$Company.update(this.$scope.client)
            .$promise
            .then(() => {
                let toast = this.$mdToast.simple()
                    .textContent(this.gettext("Client data saved!"))
                    .highlightAction(true)
                    .highlightClass("md-accent")
                    .position("bottom right");
                this.$mdToast.show(toast);
                if (this.$scope.isNew) {
                    this.$state.go("clients.list", {"createdCompany": this.$scope.client.name});
                } else {
                    this.$state.go("clients.list");
                }
            }).catch((error) => {
            if (error.data.booth) {
                this.$mdDialog.show(
                    this.$mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title(this.gettext("Error"))
                        .htmlContent(this.gettext("Can't save client info"))
                        .ariaLabel(this.gettext("Error"))
                        .ok("OK")
                );
            }
        });
    }
}

export default ClientCreateController;



// WEBPACK FOOTER //
// ./sources/components/clients/client-create/client-create.controller.js